module.exports = __webpack_public_path__ + "static/media/hero__home-page.d4a72321.jpg";